import { useUpdateUserFlags, useUserFlags } from "hooks/api/use-user-flags";

export function useGuide(guideId: string): {
  isDismissed: boolean;
  dismiss: () => void;
} {
  const { data: flags, isPending } = useUserFlags();
  const { mutate } = useUpdateUserFlags();

  // Hide tip while flags load to avoid a flash for already-dismissed users.
  const isDismissed = isPending || flags?.[guideId] === true;

  function dismiss() {
    mutate({ [guideId]: true });
  }

  return {
    isDismissed,
    dismiss,
  };
}
